<dx-data-grid
  [height]="174"
  width="100%"
  [dataSource]="dataSource"
  [allowColumnResizing]="true"
  [allowColumnReordering]="false"
  [columnAutoWidth]="true"
>
  <dxo-editing [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false" [allowResizing]="false">
  </dxo-editing>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-scrolling
    mode="virtual"
    columnRenderingMode="virtual"
    rowRenderingMode="virtual"
    showScrollbar="always"
    useNative="false"
    preloadEnabled="true"
  ></dxo-scrolling>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="false"></dxo-header-filter>
  <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-search-panel [visible]="false" [width]="240" placeholder="Search..."></dxo-search-panel>

  <dxi-column
    dataField="StartDateTime"
    dataType="date"
    caption="Date/Time"
    format="d MMM yyyy HH:mm"
    sortIndex="1"
    sortOrder="asc"
    [minWidth]="150"
    [width]="150"
    [allowSorting]="false"
  >
  </dxi-column>
  <dxi-column
    dataField="Resource"
    dataType="string"
    caption="Resource"
    [minWidth]="283"
    [width]="283"
    [allowSorting]="false"
  >
  </dxi-column>
  <dxi-column
    dataField="Session"
    dataType="string"
    caption="Session"
    [minWidth]="283"
    [width]="283"
    [allowSorting]="false"
  >
  </dxi-column>
</dx-data-grid>
